"use client";

import Link from "next/link";
import { SlideImage } from "./_components/slide-image";
import { useInView } from "react-intersection-observer";

export const AboutUs = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.65,
  });

  return (
    <div
      id="about"
      ref={ref}
      className="relative w-full h-fit lg:h-[110vh] bg-natura-lighter-2 overflow-hidden flex items-center justify-center"
    >
      {/* Decoration */}
      <svg
        className="absolute top-[55%] md:top-[100px] right-[2vw] md:right-[8vw] w-[170px] lg:w-[266px] lg:h-[116px]"
        viewBox="0 0 266 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="transition-all duration-[2.5s] ease-out"
          opacity="0.35"
          x="8"
          y="108"
          width="100"
          height="250"
          rx="50"
          transform="rotate(-90 8 108)"
          stroke="#FFBD58"
          strokeWidth="15"
          strokeDasharray={700}
          strokeDashoffset={inView ? 0 : 700}
        />
      </svg>

      <svg
        className="absolute -bottom-[40px] right-[20vw] rotate-180 md:block hidden"
        width="266"
        height="116"
        viewBox="0 0 266 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="transition-all duration-[2.5s] ease-out"
          opacity="0.35"
          x="8"
          y="108"
          width="100"
          height="250"
          rx="50"
          transform="rotate(-90 8 108)"
          stroke="#FFBD58"
          strokeWidth="15"
          strokeDasharray={700}
          strokeDashoffset={inView ? 0 : 700}
        />
      </svg>

      {/* Content */}
      <div className="container mx-auto flex flex-col lg:flex-row w-full h-fit lg:h-screen bg-natura-lighter-2 py-16 items-center justify-center gap-16">
        <div className="relative h-full max-w-screen overflow-hidden grid place-items-center">
          {/* Aquarium view */}
          <div className="absolute top-0 right-0 h-full lg:h-[35%] w-full z-[8888] bg-gradient-to-b from-natura-lighter-2 to-natura-lighter-2/0 hidden lg:block" />
          <div className="absolute left-0 bottom-0 h-full lg:h-[35%] w-full z-10 bg-gradient-to-t from-natura-lighter-2 to-natura-lighter-2/0 hidden lg:block" />
          <div className="absolute right-0 h-full w-[35%] bg-gradient-to-l from-natura-lighter-2 to-natura-lighter-2/0 z-50 block lg:hidden"></div>
          <div className="absolute left-0 h-full w-[35%] bg-gradient-to-r from-natura-lighter-2 to-natura-lighter-2/0 z-50 block lg:hidden"></div>
          <SlideImage />
        </div>
        {/* Description */}
        <div className="flex flex-col gap-6 max-w-[576px] px-6">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <h4 className="text-natura-darker-1 font-serifText text-base md:text-xl">
                About Us
              </h4>
              <h2 className="text-3xl md:text-4xl lg:text-5xl text-natura-primary font-serifText">
                Natura Dental Center
              </h2>
            </div>
            <p className="text-sm md:text-base lg:text-lg font-nunito font-normal text-justify">
              Natura Dental Center adalah pusat layanan kesehatan gigi dan mulut
              yang berpengalaman menangani puluhan ribu pasien sejak 2005 di
              Kota Depok. Dengan fokus memberikan solusi lengkap, mulai dari
              perawatan dasar hingga estetika kompleks, kami berkomitmen
              mengembalikan keindahan senyum alami Anda.
            </p>
          </div>
          
          <Link
            href={"/about-us"}
            className="flex items-center justify-center px-6 py-3 rounded-full bg-natura-primary hover:bg-natura-hover active:bg-natura-pressed transition-all duration-150 w-fit font-nunito text-white font-normal cursor-pointer text-xs md:text-base leading-normal"
          >
            Baca Selengkapnya
          </Link>
        </div>
      </div>
    </div>
  );
};
